import Image from "@/grandus-utils/wrappers/image/Image";

import styles from "./CardParameterItem.module.scss";

const CardParameterItem = ({ parameter }) => {

    const imageProps = parameter?.photoPath
        ? {
            photo: {
                path: parameter?.photoPath,
            },
            width: 13,
            height: 13,
            suffix: '@2x',
            type: 'png',
            alt: `Ikona ${parameter?.value}`,
        }
        : {};

    return (
        <div key={`product-card-${parameter?.id}`}
            className={`flavour ${styles.parameter} flex-shrink-0`}
        >
            {`${parameter?.name}: `}
            {imageProps?.photo?.path ? <Image {...imageProps} /> : ''}
            <strong className="font-bold ml-1">{parameter?.value}</strong>
      </div>
    );
};

export default CardParameterItem;
